import React from "react";
import Select from "react-select";
import { RelatorioItem } from "./RelatorioFinanceiroTable";

export type StatusPagamento = "Pago" | "Pendente";

export interface FiltrosRelatorio {
  franqueado?: string;
  assinante?: string;
  plano?: string;
  mesPagamento?: string; // YYYY-MM
  status?: StatusPagamento;
}

interface Props {
  dados: RelatorioItem[];
  tipoUsuario: "ADMIN" | "FRANQUIA";
  viewMode: "RESUMO_FRANQUIAS" | "DETALHE_FRANQUIA";
  filtros: FiltrosRelatorio;
  onChange: React.Dispatch<React.SetStateAction<FiltrosRelatorio>>;
}

const RelatorioFiltros: React.FC<Props> = ({
  dados,
  tipoUsuario,
  viewMode,
  filtros,
  onChange,
}) => {
  const optionsUnicas = (campo: keyof RelatorioItem) =>
    Array.from(
      new Set(dados.map(item => item[campo]).filter(Boolean))
    ).map(valor => ({
      value: String(valor),
      label: String(valor),
    }));

  return (
    <div className="bg-white p-4 rounded shadow space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {tipoUsuario === "ADMIN" && viewMode === "RESUMO_FRANQUIAS" && (
          <Select
            placeholder="Franqueado"
            options={optionsUnicas("franqueado")}
            value={
              filtros.franqueado
                ? { value: filtros.franqueado, label: filtros.franqueado }
                : null
            }
            onChange={opt =>
              onChange(f => ({ ...f, franqueado: opt?.value }))
            }
            isClearable
          />
        )}

        {viewMode === "DETALHE_FRANQUIA" && (
          <Select
            placeholder="Assinante"
            options={optionsUnicas("cliente")}
            value={
              filtros.assinante
                ? { value: filtros.assinante, label: filtros.assinante }
                : null
            }
            onChange={opt =>
              onChange(f => ({ ...f, assinante: opt?.value }))
            }
            isClearable
          />
        )}

        {viewMode === "DETALHE_FRANQUIA" && (
            <Select
                placeholder="Plano"
                options={optionsUnicas("plano")}
                value={
                filtros.plano
                    ? { value: filtros.plano, label: filtros.plano }
                    : null
                }
                onChange={opt =>
                onChange(f => ({ ...f, plano: opt?.value }))
                }
                isClearable
            />
            )}


        <Select
          placeholder="Status"
          options={[
            { value: "Pago", label: "Pago" },
            { value: "Pendente", label: "Pendente" },
          ]}
          value={
            filtros.status
              ? { value: filtros.status, label: filtros.status }
              : null
          }
          onChange={opt =>
            onChange(f => ({
              ...f,
              status: opt?.value as "Pago" | "Pendente" | undefined,
            }))
          }
          isClearable
        />

        <input
          type="month"
          className="border rounded px-3 py-2"
          value={filtros.mesPagamento ?? ""}
          onChange={e =>
            onChange(f => ({ ...f, mesPagamento: e.target.value }))
          }
        />
      </div>
    </div>
  );
};

export default RelatorioFiltros;
